export default class PlanImpressionPrixHelperController {
    constructor() {}

    close() {
        this.modalInstance.dismiss('close');
    }
}
